export function computePercentage(roomLeft: number, quota: number) {
  if (!quota) return '';

  return Math.round((roomLeft * 100) / quota) + '%';
}
